"use client";

import { Zap, Globe, Shield } from "@/components/icons";
import type { StatItem } from "@/components/ui/stat-card";

export const mobileStats: StatItem[] = [
  {
    icon: Zap,
    value: 33,
    suffix: "M+",
    label: "Mobile IPs",
    color: "color-mix(in srgb, var(--foreground) 70%, transparent)",
  },
  {
    icon: Globe,
    value: 195,
    suffix: "+",
    label: "Cities covered",
    color: "color-mix(in srgb, var(--foreground) 70%, transparent)",
  },
  {
    icon: Shield,
    value: 99.5,
    suffix: "%",
    label: "Success rate",
    color: "color-mix(in srgb, var(--foreground) 60%, transparent)",
    isFloat: true,
  },
];
